module.exports = __webpack_public_path__ + "img/cafe_pc_01_v1.1d762aea.png";